export function removeFilter(id) {
  const currentURL = window.location.href;
  const regex = new RegExp(`[?&]p${id}=[^&]*|p${id}=[^&]*&?`, "g");
  const updatedURL = currentURL.replace(regex, "");
  window.location.href = updatedURL;
}